import { create } from "zustand"

interface SessionMakeUpVerificationModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: (
    sessionBookingId: number,
    makeupSessionBookingLink: string | null
  ) => void
  sessionBookingId: number | null
  makeupSessionBookingLink: string | null
}

const initialState = {
  isOpen: false,
  sessionBookingId: null,
  makeupSessionBookingLink: null,
}

export const useSessionMakeUpVerificationModalStore =
  create<SessionMakeUpVerificationModalStore>()((set) => ({
    ...initialState,
    onClose: () => set(initialState),
    onOpen: (sessionBookingId, makeupSessionBookingLink) =>
      set({
        isOpen: true,
        sessionBookingId,
        makeupSessionBookingLink,
      }),
  }))
